import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-ui-elements',
  templateUrl: './ui-elements.component.html',
  styleUrls: ['../../assets/css/custom.css', './ui-elements.component.css']
})

export class UiElementsComponent implements OnInit {
  reactFormExample: FormGroup;
  @ViewChild('myDateTimeInput') myDateTimeInput; jqxDateTimeInputComponent;

  public phoneMask = { mask: ['(', /[1-9]/, /\d/, /\d/, ')',' ', /\d/, /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/]};

  quillSource: any;
  quillComponentCode: string;
  quillModuleCode: string;

  jqDateTimeSource: any;
  jqDateTimeComponentCode: string;
  jqDateTimeModuleCode: string;

  constructor(public toastr: ToastrService, vcr: ViewContainerRef, private route: ActivatedRoute, private slimLoadingBarService: SlimLoadingBarService) {

    this.buildQuill();
    this.quillSource = [{
        name: 'command line',
        src: '',
        rawCode: 'npm install ngx-quill'
      }, {
        name: 'app.module.ts',
        src: '',
        language: 'javascript',
        rawCode: this.quillModuleCode
      }];

    this.buildjqDateTime();
    this.jqDateTimeSource = [{
        name: 'tsconfig.json',
        src: '',
        language: 'javascript',
        rawCode: 'files: [ "node_modules/jqwidgets-framework/jqwidgets-ts/angular_jqxdatetimeinput.ts]'
      }, {
        name: 'app.module.ts',
        src: '',
        language: 'javascript',
        rawCode: this.jqDateTimeModuleCode
      }];

  }
  private fragment: string;
  cities = [
    { id: 3, name: 'Atlanta' },
    { id: 6, name: 'Boston' },
    { id: 4, name: 'Chicago' },
    { id: 2, name: 'Louisville' },
    { id: 1, name: 'Nashville' },
    { id: 7, name: 'New York City' },
    { id: 8, name: 'San Francisco' },
    { id: 5, name: 'St Louis' }
  ];

  drpItems = [
    { id: 3, text: 'Atlanta' },
    { id: 6, text: 'Boston' },
    { id: 4, text: 'Chicago' },
    { id: 2, text: 'Louisville' },
    { id: 1, text: 'Nashville' },
    { id: 7, text: 'New York City' },
    { id: 8, text: 'San Francisco' },
    { id: 5, text: 'St Louis' }
  ];



  ngOnInit() {
    this.reactFormExample = new FormGroup ({
      fname: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required)
  });
    this.slimLoadingBarService.start();
    this.route.params.subscribe(params => {
      this.fragment = params['topic'];

      try {
        document.querySelector('#' + this.fragment).scrollIntoView();
      } catch (e) { }
    });
    //$('#myTable').DataTable();
  }


  onClose() {
      this.slimLoadingBarService.reset();
  }
  onStart(){
        this.slimLoadingBarService.start();
  }

  onSuccess() {
    this.toastr.success('You are awesome.', 'Congrats!');
  }

  onError() {
    this.toastr.error('There was an error.', 'Oops!');
  }

  onWarning() {
    this.toastr.warning('You are being warned.', 'Alert!');
  }

  onInfo() {
    this.toastr.info('Just some information for you.', 'Thanks!');
  }


  public buildQuill() {
    this.quillModuleCode = `
    import { QuillModule } from 'ngx-quill';
    
    imports: [ QuillModule ],`;
  }

  public buildjqDateTime() {
    this.jqDateTimeModuleCode = `
    import { jqxDateTimeInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatetimeinput';
    
    declarations: [ jqxDateTimeInputComponent ],`;
  }

  getCustomEditorToolBar(): any {
    const toolbar = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': new Array<any>() }, { 'background': new Array<any>() }],          // dropdown with defaults from theme
        [{ 'font': new Array<any>() }],
        [{ 'align': new Array<any>() }],

        ['clean'],                                         // remove formatting button

        ['link']                         // link and image, video
      ]
    };

    return toolbar;
  }

    unmask(event) {
    if (event != null) {
      return event.replace(/\D+/g, '');
    }
  }

}


// WEBPACK FOOTER //
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/src/app/ui-elements/ui-elements.component.ts